<template>
  <div id="home_grade">
    <van-grid :column-num="3">
      <van-grid-item v-for="item in list" :key="item.id" :to="item.router" @click="exitUser(item.id)"
        style="background: #fff">
        <svg class="iconfont" aria-hidden="true">
          <use :xlink:href="item.icon" />
        </svg>
        <div class="iconfont-text">{{ item.text }}</div>
      </van-grid-item>
    </van-grid>
  </div>
</template>



<script>
import { Dialog } from "vant";
// import { Toast } from "vant";

export default {
  name: "grid",
  data() {
    return {
      key: "Q47BZ-4MJLM-3GQ6K-6XD3X-MKNOJ-CXFJ2",
      list: [
        {
          id: 1,
          text: "签到拜访",
          icon: "#icon-qiandao1",
          router: "/sign",
          bgc: "#d7f2fb",
        },
        {
          id: 2,
          text: "客户管理",
          icon: "#icon-xiangmuxinxi",
          router: "/customer/list",
          bgc: "#e5ffff",
        },
        {
          id: 3,
          text: "审批流程",
          icon: "#icon-liucheng1",
          router: "/review",
          bgc: "#efefef",
        },
        {
          id: 4,
          text: "服务派单",
          icon: "#icon-renwuzhipai",
          router: "/dispatch",
          bgc: "#ffffe9",
        },
        {
          id: 5,
          text: "销售订单",
          icon: "#icon-dingdan3-copy",
          router: "/order/list",
          bgc: "#d2ffd2",
        },
        {
          id: 6,
          text: "库存查询",
          icon: "#icon-xianhuokucun",
          router: "/stock",
          bgc: "#ffc6b0",
        },
        {
          id: 7,
          text: "商品采购",
          icon: "#icon-caigou1",
          router: "/purchase",
          bgc: "#ffc6b0",
        },
        {
          id: 8,
          text: "退货管理",
          icon: "#icon-fankui",
          router: "/returnManagement",
          bgc: "#ffc6b0",
        },
        {
          id: 9,
          text: "退出登录",
          icon: "#icon-tuichudenglu",
          router: "",
          bgc: "#ffc6b0",
        },
      ],
    };
  },
  mounted() {
    this.getLocation()
  },
  methods: {
    exitUser(id) {
      //   if (id == 8) {
      //     Toast.fail("功能暂未开放");
      //   }
      if (id != 9) return;
      Dialog.confirm({
        title: "退出登录",
        message: "确认退出登录?",
      })
        .then(() => {
          this.$router.push("/login?p=1");
        })
        .catch(() => { });
    },
    getLocation() {
      // 初始化腾讯地图定位组件
      var options = { timeout: 8000 };
      let geolocation = new qq.maps.Geolocation(this.key, "myapp"); // eslint-disable-line
      try {
        geolocation.getLocation(this.showPosition, this.showErr, options);
      } catch (error) {
        // this.locationTimeOut = false;
      }
    },
    showPosition() {
      // this.$toast.success("获取成功");
    },
    showErr() {
      //失败重新获取一直到获取成功
      this.getLocation()
      // this.$toast.success("获取失败");
    },
  },
};
</script>

<style lang="scss">
#home_grade {
  .van-grid-item {
    .van-grid-item__content {
      background-color: transparent;
    }
  }
}

.iconfont {
  width: 36px;
  height: 36px;
}
</style>
